import * as React from 'react';

import { BloodworkEntryContainer } from './containers/bloodwork-entry-container';

import { Route } from 'react-router-dom';
import { Home } from './Home';
import { ClientEntryContainer } from './containers/client-entry-container';
import { BloodworkAnalysisContainer } from './containers/bloodwork-analysis-container';
import { BloodworkAnalysisPDFContainer } from './containers/bloodwork-analysis-pdf';
import { ClientAddContainer } from './containers/client-add-container';
import { ProfileContainer } from './containers/profile-container';
import { SettingsContainer } from './containers/settings-container';
import { MyMarkersContainer } from './containers/my-markers-container';
import { MyRangesContainer } from './containers/my-ranges-container';
import { myRangesVisible } from './utils/myRangesVisibility';
import { ScrollToTop } from './ScrollToTop';

export class AppRoutes extends React.Component<{}, {}> {
  render() {
    return (
      <div>
        {/*
         * Inside the Router and above the routes, so every destination gets
         * it rather than each container remembering to.
         */}
        <ScrollToTop />
        <Route exact path="/" component={Home} />
        <Route exact path="/client/add" component={ClientAddContainer} />
        <Route
          exact
          path="/client/edit/manage"
          component={ClientEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/edit"
          component={BloodworkEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/add"
          component={BloodworkEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/edit/:clientId"
          component={BloodworkEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/analyze"
          component={BloodworkAnalysisContainer}
        />
        <Route
          exact
          path="/bloodwork/analyze/pdf"
          component={BloodworkAnalysisPDFContainer}
        />
        <Route exact path="/profile" component={ProfileContainer} />
        <Route exact path="/settings" component={SettingsContainer} />
        <Route exact path="/my-markers" component={MyMarkersContainer} />
        {myRangesVisible() && (
          <Route exact path="/my-ranges" component={MyRangesContainer} />
        )}
      </div>
    );
  }
}
